import React, { Component } from 'react'

import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Container, Card, CardBody, Row, Col, Table } from "reactstrap";


import TestimonyListCard from "./TestimonyListCard"
import { testimonyUrl } from '../../helpers/url';

export default class TestimonyList extends Component {
    constructor(props) {
        super(props);
        this.state = ({
            breadcrumbItems : [
                { title : "Dashboard", link : "/dashboard" },
                { title : "Testimony List", link : "/testimonyList" },
            ],
            data: [],
            tempPid: [],
        })
    }

    componentDidMount() {
        const jwt = JSON.parse(sessionStorage.getItem('authUser'));
		const accessToken = jwt.jwtToken;

        fetch(testimonyUrl, {
            method: "GET",
            headers: {"Content-Type": "application/json", "Authorization": accessToken}
        })
        .then(res=>res.json())
        .then(response => {
            let data = [];
            let tempPid = []
            response.map(each => data.push(each.person))
            response.map(each => tempPid.push(each.tempPid))
            this.setState({
                data,
                tempPid
            })
        })
        .catch(err => {
            console.log("error", err)
        })
    }

    test = () => {
        console.log("d", this.state.data)
        console.log("tempPid", this.state.tempPid)
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                    <Breadcrumbs title="List of Pending Testimony for Verification" breadcrumbItems={this.state.breadcrumbItems} />
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        <div className="table-responsive">
                                            <Table className="table-centered mb-0 table-nowrap">
                                                <thead className="bg-light">
                                                    <tr>
                                                        <th style={{width:"120px"}}>Image</th>
                                                        <th>Name</th>
                                                        <th>Age</th>
                                                        <th>Birth Place</th>
                                                        <th>Short Description</th>
                                                        <th className="text-center">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                        {this.state.data.map((each, id) => 
                        
                            <TestimonyListCard 
                                key={id}
                                firstname={each.firstName}
                                lastname={each.lastName}
                                age={each.age}
                                placeOfBirth={each.placeOfBirth}
                                gender={each.gender}
                                img={each.imageS3location}
                                tempPid={this.state.tempPid[id]}
                            />
                        
                        )}
                         </tbody>
                                            </Table>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
